// src/components/index.js
import Vue from 'vue'

// 批量读取当前目录下的 .vue 文件（不包括子文件夹）
const requireComponent = require.context(
  './', // 其组件目录的相对路径
  false, // 是否查询其子目录
  /\w+\.vue$/ // 匹配基础组件文件名的正则表达式（匹配所有 .vue 文件）
)

requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)

  // 获取组件的 PascalCase 命名（例如 FloatingBack.vue -> FloatingBack）
  const componentName = fileName
    .replace(/^\.\//, '') // 去掉开头的 ./
    .replace(/\.\w+$/, '') // 去掉文件后缀 .vue

  // 全局注册组件
  Vue.component(componentName, componentConfig.default || componentConfig)
})
